import React from 'react'
import PreceptorCard from './PreceptorCard'
import Button from 'components/common/buttons/Button'
import { useHistory } from 'react-router'
import { getPreceptores } from 'services/academic'
import withCards, { CardContext } from 'hoc/withCards'
import ListFilter from 'components/common/list-filter/ListFilter'
const PreceptorPage = ( { renderLoading, onChangeForm } ) => {
    const history = useHistory()

    return (
        <>
            <Button onClick={() => history.push( 'preceptores/new' )}>
                Cadastrar novo preceptor
            </Button>
            <ListFilter onValueChange={onChangeForm} className={"mt-2 mr-10 ml-10"}/>
            <CardContext.Consumer>
                {( { cards } ) =>
                    renderLoading() || (
                        <>
                            {cards.map( ( card ) => (
                                <div className="card-deck">
                                    <PreceptorCard key={card.id} card={card} />
                                </div>
                            ) )}
                        </>
                    )
                }
            </CardContext.Consumer>
        </>
    )
}

export default withCards( {
    fetch: getPreceptores,
    title: 'Preceptores',
    noResultsText: 'Não existem preceptores.',
} )( PreceptorPage )
